import { type ServiceMethod } from '@/application/interfaces/service';
import { type ItemId } from '@/infra/services/catalog/model';
import { type Seller } from '@/infra/services/catalog/product/get-sellers/model';
import { type ErrorResponse as BaseErrorResponse } from '@/infra/services/model';

import adapter from './adapter';
import { type Category, type Product } from './model';

export type Params = {
  itemId: ItemId;
};

export type ExternalResponse = {
  data: {
    product: Product;
    category: Category;
    currentSeller?: Seller;
  };
};

export type Response = {
  data: {
    product: Product;
    category: Category;
    currentSeller: Seller;
  };
};

export type ErrorResponse = BaseErrorResponse<
  'product_unavailable' | 'product_not_found'
> & {
  meta?: {
    categoryUrl: string;
    categoryName: string;
    title: string;
    isAVS: boolean;
  };
};

const getProductInfo: ServiceMethod<Response, Params> =
  (httpClient) => async (data, options) => {
    const { itemId } = data;

    const { body: response } = await httpClient.get<Response, Params>(
      '/api/v3/products/{itemId}',
      {
        ...options,
        params: {
          itemId,
        },
      }
    );

    return adapter(response);
  };

export default getProductInfo;
